<template>
  <div id="component-container" style="padding: 20px; overflow: auto">
    <div class="wrapper">

      <div class="home-table">
        <span style="height: 20%; padding: 10px;">{{$t('table.home.title')}}</span>
        <b-table height="80%" striped hover bordered fixed :items="tableData" :fields="fields"></b-table>
      </div>
      <router-link class="box box1 box-g" :to="{name: 'Pos', params: {taskId: this.taskId}}">{{$t('menu.pos')}}</router-link>
      <router-link class="box box2 box-r" :to="{name: 'Lemma', params: {taskId: this.taskId}}">{{$t('menu.lemma')}}</router-link>
      <router-link class="box box3" :to="{name: 'LemmaDif', params: {taskId: this.taskId}}">{{$t('menu.lemma_dif')}}</router-link>
      <router-link class="box box4" :to="{name: 'Ne', params: {taskId: this.taskId}}">{{$t('menu.ne')}}</router-link>
      <router-link class="box box5 box-b" :to="{name: 'Term', params: {taskId: this.taskId}}">{{$t('menu.term')}}</router-link>
      <router-link class="box box6 box-r" :to="{name: 'Verbs', params: {taskId: this.taskId}}">{{$t('menu.verbs')}}</router-link>
      <router-link class="box box7 box-g" :to="{name: 'SentStat', params: {taskId: this.taskId}}">{{$t('menu.sentstat')}}</router-link>
    </div>
  </div>
</template>

<script>
  import BarChart from '../components/BarChart'
  import axios from 'axios'

  export default {
    name: 'Home',
    props: {
      taskId: {
        type: String
      }
    },
    components: {BarChart, axios},
    data () {
      return {
        resultData: null,
        tableData: [],
        show: false
      }
    },
    created () {
      console.log('task:' + process.env.ROOT_API + 'getData/' + this.taskId + '/base')
      axios.get(process.env.ROOT_API + 'getData/' + this.taskId + '/base')
              .then((response) => {
                if (response.data.error === 'corpus not processed') {
                  console.log(response.data.error)
                  this.$router.push({path: '/'})
                } else {
                  if (Object.keys(response.data).length > 0) {
                    this.resultData = response.data
                    this.mapData()
                  }
                }
              }).catch(function (error) {
                // handle error
                alert(error)
              })
              .finally(function () {
                // always executed
              })
    },
    computed: {
      fields: function () {
        return [
          {
            key: 'name',
            label: this.$t('table.home.name'),
            sortable: false
          },
          {
            key: 'sentences',
            label: this.$t('table.home.sentences'),
            sortable: false
          },
          {
            key: 'tokens',
            label: this.$t('table.home.tokens'),
            sortable: false
          }
        ]
      }
    },
    methods: {
      mapData () {
        for (var corpora in this.resultData) {
          this.tableData.push(
                  {
                    'name': this.resultData[corpora].name,
                    'sentences': this.resultData[corpora].sentences,
                    'tokens': this.resultData[corpora].tokens
                  }
          )
        }
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .box {
    background-color: var(--golden);
    color: #fff;
    padding: 20px;
    font-size: 100%;
    grid-area: box;
  }
  .box:hover {
    transition-duration: 0.5s;
    background-color: var(--golden_hover);
    cursor: pointer;
  }
  .box-un {
    background-color: #c7c7c7;
    color: #939393;
    padding: 20px;
    font-size: 100%;
    grid-area: box;
  }
  a.box:hover {
    text-decoration: inherit !important;
  }
  .box-r {
    background-color: #e03e31;
  }
  .box-r:hover {
    background-color: #ff4a35;
  }
  .box-b {
    background-color: #1f8de5;
  }
  .box-b:hover {
    background-color: #1fa7ff;
  }
  .box-g {
    background-color: #3eaf40;
  }
  .box-g:hover {
    background-color: #44c246;
  }
  /*'#f44336', '#2196f3', '#ffc107', '#4caf50'*/
  /*.box:nth-child(4n+2) {*/
  /*background-color: #ccc;*/
  /*color: #000;*/

  /*}*/
  /*.box:nth-child(4n+3) {*/
  /*background-color: #ccc;*/
  /*color: #000;*/
  /*}*/
  /*.wrapper {*/
  /*justify-content: center;*/
  /*margin: 0;*/
  /*padding: 10px;*/
  /*width: 100%;*/
  /*display: grid;*/
  /*grid-gap: 10px;*/
  /*grid-template-columns: repeat(3, 100px);*/
  /*grid-template-rows: 100px 100px 100px 100px;*/
  /*grid-auto-flow: column;*/
  /*}*/
  .home-table {
    grid-area: table;
    text-align: center;
    position: relative;
  }
  .box1 {grid-area: box1;}
  .box2 {grid-area: box2;}
  .box3 {grid-area: box3;}
  .box4 {grid-area: box4;}
  .box5 {grid-area: box5;}
  .box6 {grid-area: box6;}
  .box7 {grid-area: box7;}
  .wrapper {
    height: 100%;
    display: grid;
    grid-gap: 30px;
    grid-template-areas:
            "table"
            "box1"
            "box2"
            "box3"
            "box4"
            "box7"
            "box5"
            "box6"
  ;
  }
  @media only screen and  (min-width: 500px) {
    .wrapper {
      width: 80%;
      margin: 0 10%;
      grid-template-columns: 1fr 1fr 1fr ;
      grid-template-areas:
              "table table box2"
              "table table box2"
              "box5 box1 box3"
              "box5 box1 box3"
              "box6 box4 box7"
    }
    nav ul {
      display: flex;
      justify-content: space-between;
    }
  }
  @media only screen and (min-width: 768px) {
    .wrapper {
      grid-template-columns: 1fr 1fr 1fr 1fr ;
      grid-template-areas:
              "table table box2 box7"
              "table table box2 box4"
              "box5 box1 box3 box6"
              "box5 box1 box3 box6"
    }
    .box .box-un{
      font-size: 150%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Home.vue